import UnileverAnimation from '../components/UnileverAnimation';

export default function LoadingBox() {
  return (
    <div style={{ width: '100%', height: '100%' }} className="alignDataCenter">
      <UnileverAnimation />
      {/* <h4 className="text-center">Loading...</h4> */}
    </div>
  );
}
